import { render, staticRenderFns } from "./collectCardSuccess.vue?vue&type=template&id=0e1e9d5a&scoped=true&"
import script from "./collectCardSuccess.vue?vue&type=script&lang=js&"
export * from "./collectCardSuccess.vue?vue&type=script&lang=js&"
import style0 from "./collectCardSuccess.vue?vue&type=style&index=0&id=0e1e9d5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1e9d5a",
  null
  
)

export default component.exports